module.exports = __webpack_public_path__ + "img/t_0016.4b95ac6e.gif";